import RenameStage from './RenameStage';
import './RenameStage.scss';

export default RenameStage;
